var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { PureComponent } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import Errors from "../shared/errors";
import Busy from "../shared/busy";
import { getXSRF } from "../../src/Services/Shared/FetchService";
// @ts-expect-error - TS7006 - Parameter 'startIndex' implicitly has an 'any' type. | TS7006 - Parameter 'endIndex' implicitly has an 'any' type.
const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
};
class AlertRulesList extends PureComponent {
    static fetchAlertRules(alertId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(`/aviso/alertRule/list?alertId=${alertId}`, {
                credentials: "include",
            });
            const responseJson = yield response.json();
            return responseJson.data;
        });
    }
    static updateExecutionOrder(alertId, alertRules) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch("/aviso/alertRule/updateExecutionOrder", {
                credentials: "include",
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-XSRF-TOKEN": getXSRF(),
                },
                body: JSON.stringify({
                    alertId,
                    rules: alertRules,
                }),
            });
            const responseJson = yield response.json();
            return responseJson.data;
        });
    }
    constructor() {
        // @ts-expect-error - TS2554 - Expected 1-2 arguments, but got 0.
        super();
        this.state = {
            alertRules: null,
            errors: [],
            isLoading: false,
            isDeleting: false,
            deletingRule: null,
        };
        this.delete = this.delete.bind(this);
        this.onDragEnd = this.onDragEnd.bind(this);
    }
    componentDidMount() {
        this.loadAlertRules();
    }
    // @ts-expect-error - TS7006 - Parameter 'result' implicitly has an 'any' type.
    onDragEnd(result) {
        // dropped outside the list
        if (!result.destination) {
            return;
        }
        const alertRules = reorder(
        // @ts-expect-error - TS2345 - Argument of type 'null' is not assignable to parameter of type '[]'.
        this.state.alertRules, result.source.index, result.destination.index);
        this.setState({
            alertRules,
        });
        this.saveRuleOrder();
    }
    // @ts-expect-error - TS7006 - Parameter 'message' implicitly has an 'any' type.
    onError(message) {
        this.setState({ errors: [...this.state.errors, message] });
    }
    loadAlertRules() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this.setState({ isLoading: true });
                const alertRules = yield AlertRulesList.fetchAlertRules(this.props.alertId);
                this.setState({ alertRules });
            }
            catch (err) {
                this.onError(`Error loading alert rules: ${err}`);
            }
            finally {
                this.setState({ isLoading: false });
            }
        });
    }
    saveRuleOrder() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield AlertRulesList.updateExecutionOrder(this.props.alertId, 
                // @ts-expect-error - TS2345 - Argument of type 'null' is not assignable to parameter of type '[]'.
                this.state.alertRules);
            }
            catch (err) {
                this.onError(`Error updating alert rules: ${err}`);
            }
        });
    }
    refresh() {
        this.loadAlertRules();
    }
    // @ts-expect-error - TS7006 - Parameter 'rule' implicitly has an 'any' type.
    delete(rule) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this.setState({
                    isDeleting: true,
                    // @ts-expect-error - TS2345 - Argument of type '{ isDeleting: true; deletingRules: any; }' is not assignable to parameter of type 'State | ((prevState: Readonly<State>, props: Readonly<Props>) => State | Pick<State, keyof State> | null) | Pick<...> | null'.
                    deletingRules: rule,
                });
                const response = yield fetch(`/aviso/alertRule/delete?id=${rule.id}`, {
                    credentials: "include",
                    method: "POST",
                    headers: {
                        "X-XSRF-TOKEN": getXSRF(),
                    },
                });
                const responseJson = yield response.json();
                if (responseJson.success) {
                    this.loadAlertRules();
                }
                else {
                    this.onError(responseJson.message);
                }
            }
            catch (err) {
                this.onError(`Error removing alert rule: ${err}`);
            }
            finally {
                this.setState({
                    isDeleting: false,
                    deletingRule: null,
                });
            }
        });
    }
    renderAlertRules() {
        // @ts-expect-error - TS2339 - Property 'length' does not exist on type 'never'.
        if (!this.state.alertRules || !this.state.alertRules.length) {
            return (_jsx("div", { className: "form-group", children: _jsxs("div", { className: "alert alert-warning", role: "alert", children: [_jsx("span", { className: "fa fa-exclamation-circle", "aria-hidden": "true" }), " No Alert Rules configured. No alerts will be created."] }) }));
        }
        return (_jsx(DragDropContext, { onDragEnd: this.onDragEnd, children: _jsx(Droppable, { droppableId: "droppable", children: (dropProvided) => (_jsxs("div", { className: "list-group", ref: dropProvided.innerRef, children: [this.state.alertRules.map((rule, index) => (_jsx(Draggable, { draggableId: rule.id, index: index, children: (dragProvided) => (_jsx("div", Object.assign({ className: "list-group-item", ref: dragProvided.innerRef }, dragProvided.draggableProps, dragProvided.dragHandleProps, { children: _jsxs("div", { className: "d-flex justify-content-between align-items-center", children: [_jsxs("div", { children: [this.props.allowDelete && (_jsxs("button", { type: "button", className: "btn btn-link text-danger", title: "Delete", onClick: () => this.delete(rule), disabled: this.state.isDeleting &&
                                                        this.state.deletingRule === rule, children: [this.state.isDeleting &&
                                                            this.state.deletingRule === rule ? (_jsx(Busy, {})) : (_jsx("span", { className: "fas fa-trash", "aria-hidden": "true" })), _jsx("span", { className: "sr-only", children: "Delete" })] })), "For courses where", _jsxs("b", { children: [" ", rule.property.displayName] }), rule.operator.id !== 1 ? " is" : "", _jsxs("i", { children: [" ", rule.operator.name] }), _jsxs("b", { children: [" ", rule.comparator] }), ", create an alert after a student has", _jsxs("b", { children: [" ", rule.result, " "] }), rule.result === "1" ? " absence" : " absences", rule.includeExcusedAbsences
                                                    ? ", including excused absences"
                                                    : null, "."] }), _jsx("div", { children: _jsx("span", { className: "fas fa-grip-horizontal", "aria-hidden": "true", title: "Drag to reorder this rule" }) })] }) }))) }, rule.id))), dropProvided.placeholder] })) }) }));
    }
    render() {
        if (this.state.isLoading) {
            return (_jsx("div", { children: _jsx(Busy, { isBusy: this.state.isLoading }) }));
        }
        return (_jsxs("div", { children: [this.renderAlertRules(), _jsx(Errors, { errors: this.state.errors })] }));
    }
}
AlertRulesList.defaultProps = {
    allowDelete: false,
};
export default AlertRulesList;
